import BookingCard from "@/components/BookingCard/BookingCard";
import moment from 'moment';
import React, { useEffect } from 'react';
import useUserContext from "@/hooks/useUserContext";
import { useTypedLazyQuery } from "@/hooks/useZeus";
import { $, BookingStatus, PaymentStatus, SortOrder} from "@/generated/zeus";
import { BookingFragment, bookingSelector } from "./types";
import ButtonPrimary from "@/shared/Button/ButtonPrimary";
import { fireEvent } from "@/lib/utils";

const today = moment()

export default function BookingCardsTab() {
  const {user} = useUserContext();

  const [getBookings,{ data, loading, refetch }] = useTypedLazyQuery({
    bookings:[{
      orderBy:[{
        bookingDate:SortOrder.desc
      }],
      take:$('take','Int'),
      where:{
        
        AND:[{
          paymentStatus:{
            notIn:[PaymentStatus.PENDING]
          },
          OR:[{
            user:{
              is:{
                email:{
                  equals:user?.email
                }
              }
            }
          },{
            sharedUsers:{
              some:{
                email:{
                  equals:user?.email
                }
              }
            }
          }],
        }]
      }
    },bookingSelector]
  },{
    variables:{
      take:10
    },
    notifyOnNetworkStatusChange:true
  })

  function showMore(){
    fireEvent('booking.showMore.click')
    getBookings({
      variables:{
        take:10+(data?.bookings?.length||0)
      }
    })
  }

  useEffect(()=>{
    if(user?.email){
      getBookings()
    }
  },[user])

  const [bookings,setBookings] = React.useState<{
    upcomingBookings: BookingFragment[],
    completedBookings:BookingFragment[] 
  }>({
    upcomingBookings:[], 
    completedBookings:[]
  });

  useEffect(()=>{
    if(data?.bookings &&data?.bookings?.length>0){
      const upcomingBookings:any = [];
      const completedBookings:any = [];
      for(const bookingFragment of data.bookings){
        const booking = bookingFragment;
        if(moment(booking.selectedDates.endDate).diff(today,'days') >= 0 && booking.bookingStatus != BookingStatus.CANCELLED){
          upcomingBookings.push(booking); 
        } else{
          completedBookings.push(booking);
        }
      }
      setBookings({
        upcomingBookings,
        completedBookings
      })
    }

  },[data])

  return (
    <div className="grid grid-cols-1 gap-6 ">
      {!loading && data?.bookings?.length==0 && <div className="flex mt-12 justify-center items-center">
        <h4 className='text-lg'>
            You have no bookings.
        </h4>
      </div>
      }
      {user?.email &&
      <>
        <div className="flex gap-4 flex-col">
          {bookings.upcomingBookings?.map((item) => (
            <BookingCard refresh={refetch} key={item.id} data={item} />
          ))}
          {bookings.completedBookings?.map((item) => (
            <BookingCard refresh={refetch} key={item.id} data={item} />
          ))}
        </div>
          
        <div className="flex mt-12 justify-center items-center">
          <ButtonPrimary loading={loading} onClick={showMore}>{!user||loading ? 'Loading...':'Show more'}</ButtonPrimary>
        </div>
      
      </>
      }
      
    </div>
  ) 
}
